import { default as form } from './formReducer';
import { default as errors } from './errorsReducer';
import { default as settings } from './settingsReducer';
import { default as servicePartner } from './servicePartnerReducer';
import { default as installations } from './installationReducer';
import { default as materials } from './materialsReducer';
import { default as productRanges } from './productRangesReducer';

export default { form, errors, settings, servicePartner, installations, materials, productRanges };
